import React from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';

const sortIconMap = {
	asc: <IoIosArrowRoundUp className="sort-arrow-icon" />,
	desc: <IoIosArrowRoundDown className="sort-arrow-icon" />,
};

const getHeaderTestId = (field) => {
	const fieldMap = {
		'LIST NAME': 'list-name',
		'DESCRIPTION': 'description',
		'CREATED DATE': 'created-date',
		'PRODUCT COUNT': 'product-count',
		'PRODUCTNAME': 'product-name',
		'PRODUCT NAME': 'product-name',
		'UPC': 'upc',
		'CATEGORY': 'category',
		'AVAILABLE STOCK': 'available-stock',
		'UNIT PRICE': 'unit-price',
	};
	return fieldMap[field] || String(field).toLowerCase().replace(/[\s_]+/g, '-');
};

export const HeaderCell = ({ field, label, handleSort, sortDirection, isRight }) => (
	<div
		className={`d-flex align-items-center ${isRight ? 'justify-content-end gap-1' : 'justify-content-between'} w-100 cursor-pointer`}
		onClick={() => handleSort && handleSort(field)}
		data-testid={`product-list-header-${getHeaderTestId(field)}`}
	>
		<span className="fw-bold text-dark">{label}</span>
		<span>{sortIconMap[sortDirection?.[field]]}</span>
	</div>
);

export const getListTableColumns = (handleSort, sortDirection = {}) => [
	{
		field: 'LIST NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 240,
		flex: 1.5,
		checkboxSelection: true,
		headerCheckboxSelection: true,
		headerComponent: () => <HeaderCell field="LIST NAME" label="LIST NAME" handleSort={handleSort} sortDirection={sortDirection} />,
	},
	{
		field: 'DESCRIPTION',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 250,
		flex: 2,
		headerComponent: () => <HeaderCell field="DESCRIPTION" label="DESCRIPTION" handleSort={handleSort} sortDirection={sortDirection} />,
	},
	{
		field: 'CREATED DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => <HeaderCell field="CREATED DATE" label="CREATED DATE" handleSort={handleSort} sortDirection={sortDirection} />,
	},
	{
		field: 'PRODUCT COUNT',
		headerClass: 'HeaderBg right-align',
		cellClass: 'right-align',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => <HeaderCell field="PRODUCT COUNT" label="PRODUCT COUNT" handleSort={handleSort} sortDirection={sortDirection} isRight={true} />,
	},
];
